import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import ResponsiveMobileStepper from "./ResponsiveMobileStepper";
import NextBackButtons from "./NextBackButtons";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Typography } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { Formik } from "formik";
import * as yup from "yup";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import moment from "moment";
import CircularProgress from "@material-ui/core/CircularProgress";
import runtimeEnv from "@mars/heroku-js-runtime-env";
import axios from "axios";

const styles = (theme) => ({
  root: {
    textAlign: "center",
  },
  introText: {
    fontSize: 32,
    maxWidth: 775,
    paddingBottom: theme.spacing(8),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  helperText: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: ".5rem",
    opacity: 0.8,
    textAlign: "center",
    width: 200,
  },
});

class MovingDate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      minDaysBufferToBook: 0,
      loading: true,
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });

    return axios
      .get(runtimeEnv().REACT_APP_API_URL + "/minDaysBufferToBook")
      .then((response) => {
        this.setState({
          minDaysBufferToBook: response?.data?.minDaysBufferToBook,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error); //eslint-disable-line no-console
        console.log(error.response); //eslint-disable-line no-console

        this.setState({
          loading: false,
        });
      });
  }

  render() {
    const { classes } = this.props;
    return (
      (this.state.loading && (
        <div style={{ margin: "40px auto 40px auto", textAlign: "center" }}>
          <CircularProgress />
        </div>
      )) || (
        <Formik
          validateOnChange={true}
          validationSchema={yup.object({
            date: yup.date().label("Date").required(),
          })}
          initialValues={
            (!(
              Object.entries(this.props.values).length === 0 &&
              this.props.values.constructor === Object
            ) &&
              this.props.values) || {
              //If there are already values, use those - make sure it's not just an empty object though, see https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
              date: null,
            }
          }
          onSubmit={(values, actions) => {
            window.dataLayer.push({
              event: "select-date",
              eventProps: {
                category: "Ecommerce",
                action: "Click",
                label: "Page 2 - Select Date",
              },
            });

            actions.setSubmitting(false);
            this.props.handleNext(values);
          }}
          render={({
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldError,
            isSubmitting,
          }) => (
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid className={classes.root}>
                <Typography className={classes.introText}>
                  Choose your moving date
                </Typography>
                <Grid className={classes.datePicker}>
                  <DatePicker
                    required
                    minDate={moment().add(
                      this.state.minDaysBufferToBook,
                      "days"
                    )}
                    name="date"
                    placeholder="Pick a date"
                    className={classes.textField}
                    margin="normal"
                    inputVariant="outlined"
                    format="LL"
                    disabled={isSubmitting}
                    value={values.date}
                    onChange={(date) =>
                      date && setFieldValue("date", date, true)
                    }
                    onBlur={handleBlur}
                    helperText={touched.date && errors.date}
                    error={touched.date && !!errors.date}
                    // eslint-disable-next-line no-unused-vars
                    onError={(_, error) => setFieldError("date", error)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position={"end"}>
                          <CalendarTodayIcon style={{ fill: "#757575" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Typography className={classes.helperText}>
                  No set date? Your best guess is fine for now.
                </Typography>
              </Grid>
              <NextBackButtons disableBack={true} disableBoth={isSubmitting} />
              <ResponsiveMobileStepper
                steps={this.props.steps}
                activeStep={this.props.activeStep}
                disableBack={true}
              />
            </form>
          )}
        />
      )
    );
  }
}

MovingDate.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
};

export default withStyles(styles)(MovingDate);
